import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MailService } from '../../services/mail.service';
import '../../../assets/js/smtp.js';

declare var swal: any;
declare var $: any;

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styles: [
  ]
})
export class ContactoComponent implements OnInit {

  nombre: string;
  correo: string;
  telefono: string;
  asunto: string;
  mensaje: string;


  constructor(public mailService: MailService) { }

  ngOnInit(): void {
  }


  sendEmail(f: NgForm) {

    console.log('Enviando  ' + f.invalid);

    if (f.invalid) {
      return;
    }
    let body = '';
    body += ' Nombre y Apeliido: ' + this.nombre + '<br> ';
    body += ' Numero de contacto: ' + this.telefono + '<br>';

    if (this.correo) {
      body += ' Correo electronico: ' + this.correo + '<br>  ';
    }
    body += ' Asunto: ' + this.asunto + '<br>';
    body += ' Mensaje: <br> <br> ' + this.mensaje;




    this.mailService.enviar(body).subscribe();
    swal('¡Mensaje Enviado!', 'En breve nos comunicaremos con UD.', 'success');

    f.reset();
  }

}
